module.exports = __webpack_public_path__ + "media/images/icon__community-b0034514a2f9dadba7557be16ebbf1b9.png";